export const modalSelector = (state) => state.get('modal');
